import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LogConsumoSefazListarRequest } from '../../requests/dfe/log-consumo-sefaz-listar.request';
import { LogConsumoSefazListarResponse } from '../../responses/dfe/log-consumo-sefaz-listar.response';

@Injectable({
  providedIn: 'root',
})
export class LogConsumoSefazService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}log-consumo-servico-sefaz`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(request: LogConsumoSefazListarRequest, pageIndex: number = 0): Observable<LogConsumoSefazListarResponse> {
    const params = new HttpParams().set('pageIndex', pageIndex.toString());
    return this.httpClient
      .post<LogConsumoSefazListarResponse>(`${this.apiUrl}/getAll`, request, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }
}
